module.exports = __webpack_public_path__ + "static/media/logo154.59d1f6ec.png";